import { render, staticRenderFns } from "./AddClinicalProfile.vue?vue&type=template&id=3376549b&"
import script from "./AddClinicalProfile.vue?vue&type=script&lang=js&"
export * from "./AddClinicalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports